import * as re from "react";
import et, { forwardRef as Ke, useContext as Lt } from "react";
import { css as M } from "@emotion/react";
import { globalColor as Ue, illaPrefix as Be, applyBoxStyle as gr, deleteCssProps as br } from "@illa-design/theme";
import { Divider as fr } from "@illa-design/divider";
import jt from "rc-virtual-list";
import { Typography as lr, Text as dr, Paragraph as Vt } from "@illa-design/typography";
import { Avatar as Yt } from "@illa-design/avatar";
var pr = { exports: {} }, be = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vr;
function Wt() {
  if (Vr)
    return be;
  Vr = 1;
  var e = et, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(u, p, h) {
    var d, E = {}, N = null, $ = null;
    h !== void 0 && (N = "" + h), p.key !== void 0 && (N = "" + p.key), p.ref !== void 0 && ($ = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (E[d] = p[d]);
    if (u && u.defaultProps)
      for (d in p = u.defaultProps, p)
        E[d] === void 0 && (E[d] = p[d]);
    return { $$typeof: r, type: u, key: N, ref: $, props: E, _owner: o.current };
  }
  return be.Fragment = n, be.jsx = l, be.jsxs = l, be;
}
var _e = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yr;
function zt() {
  return Yr || (Yr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = et, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), u = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), N = Symbol.for("react.lazy"), $ = Symbol.for("react.offscreen"), A = Symbol.iterator, b = "@@iterator";
    function D(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = A && t[A] || t[b];
      return typeof s == "function" ? s : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var s = arguments.length, f = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          f[m - 1] = arguments[m];
        T("error", t, f);
      }
    }
    function T(t, s, f) {
      {
        var m = _.ReactDebugCurrentFrame, R = m.getStackAddendum();
        R !== "" && (s += "%s", f = f.concat([R]));
        var I = f.map(function(S) {
          return String(S);
        });
        I.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, I);
      }
    }
    var k = !1, c = !1, L = !1, y = !1, X = !1, Oe;
    Oe = Symbol.for("react.module.reference");
    function Qe(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || X || t === o || t === h || t === d || y || t === $ || k || c || L || typeof t == "object" && t !== null && (t.$$typeof === N || t.$$typeof === E || t.$$typeof === l || t.$$typeof === u || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Oe || t.getModuleId !== void 0));
    }
    function er(t, s, f) {
      var m = t.displayName;
      if (m)
        return m;
      var R = s.displayName || s.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function Pe(t) {
      return t.displayName || "Context";
    }
    function K(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case h:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            var s = t;
            return Pe(s) + ".Consumer";
          case l:
            var f = t;
            return Pe(f._context) + ".Provider";
          case p:
            return er(t, t.render, "ForwardRef");
          case E:
            var m = t.displayName || null;
            return m !== null ? m : K(t.type) || "Memo";
          case N: {
            var R = t, I = R._payload, S = R._init;
            try {
              return K(S(I));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, Ne, Ae, pe, $e, ve, ke, Ie;
    function De() {
    }
    De.__reactDisabledLog = !0;
    function rr() {
      {
        if (ne === 0) {
          Ne = console.log, Ae = console.info, pe = console.warn, $e = console.error, ve = console.group, ke = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: De,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function tr() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, t, {
              value: Ne
            }),
            info: Q({}, t, {
              value: Ae
            }),
            warn: Q({}, t, {
              value: pe
            }),
            error: Q({}, t, {
              value: $e
            }),
            group: Q({}, t, {
              value: ve
            }),
            groupCollapsed: Q({}, t, {
              value: ke
            }),
            groupEnd: Q({}, t, {
              value: Ie
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var he = _.ReactCurrentDispatcher, me;
    function oe(t, s, f) {
      {
        if (me === void 0)
          try {
            throw Error();
          } catch (R) {
            var m = R.stack.trim().match(/\n( *(at )?)/);
            me = m && m[1] || "";
          }
        return `
` + me + t;
      }
    }
    var ye = !1, ie;
    {
      var nr = typeof WeakMap == "function" ? WeakMap : Map;
      ie = new nr();
    }
    function v(t, s) {
      if (!t || ye)
        return "";
      {
        var f = ie.get(t);
        if (f !== void 0)
          return f;
      }
      var m;
      ye = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var I;
      I = he.current, he.current = null, rr();
      try {
        if (s) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ee) {
              m = ee;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ee) {
              m = ee;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            m = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && m && typeof ee.stack == "string") {
          for (var x = ee.stack.split(`
`), U = m.stack.split(`
`), F = x.length - 1, j = U.length - 1; F >= 1 && j >= 0 && x[F] !== U[j]; )
            j--;
          for (; F >= 1 && j >= 0; F--, j--)
            if (x[F] !== U[j]) {
              if (F !== 1 || j !== 1)
                do
                  if (F--, j--, j < 0 || x[F] !== U[j]) {
                    var G = `
` + x[F].replace(" at new ", " at ");
                    return t.displayName && G.includes("<anonymous>") && (G = G.replace("<anonymous>", t.displayName)), typeof t == "function" && ie.set(t, G), G;
                  }
                while (F >= 1 && j >= 0);
              break;
            }
        }
      } finally {
        ye = !1, he.current = I, tr(), Error.prepareStackTrace = R;
      }
      var fe = t ? t.displayName || t.name : "", jr = fe ? oe(fe) : "";
      return typeof t == "function" && ie.set(t, jr), jr;
    }
    function Ee(t, s, f) {
      return v(t, !1);
    }
    function se(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function ae(t, s, f) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, se(t));
      if (typeof t == "string")
        return oe(t);
      switch (t) {
        case h:
          return oe("Suspense");
        case d:
          return oe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return Ee(t.render);
          case E:
            return ae(t.type, s, f);
          case N: {
            var m = t, R = m._payload, I = m._init;
            try {
              return ae(I(R), s, f);
            } catch {
            }
          }
        }
      return "";
    }
    var Me = Object.prototype.hasOwnProperty, Tr = {}, Or = _.ReactDebugCurrentFrame;
    function Fe(t) {
      if (t) {
        var s = t._owner, f = ae(t.type, t._source, s ? s.type : null);
        Or.setExtraStackFrame(f);
      } else
        Or.setExtraStackFrame(null);
    }
    function Et(t, s, f, m, R) {
      {
        var I = Function.call.bind(Me);
        for (var S in t)
          if (I(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var U = Error((m || "React class") + ": " + f + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw U.name = "Invariant Violation", U;
              }
              x = t[S](s, S, m, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (F) {
              x = F;
            }
            x && !(x instanceof Error) && (Fe(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", f, S, typeof x), Fe(null)), x instanceof Error && !(x.message in Tr) && (Tr[x.message] = !0, Fe(R), g("Failed %s type: %s", f, x.message), Fe(null));
          }
      }
    }
    var gt = Array.isArray;
    function ar(t) {
      return gt(t);
    }
    function bt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, f = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return f;
      }
    }
    function _t(t) {
      try {
        return Pr(t), !1;
      } catch {
        return !0;
      }
    }
    function Pr(t) {
      return "" + t;
    }
    function Nr(t) {
      if (_t(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", bt(t)), Pr(t);
    }
    var ge = _.ReactCurrentOwner, xt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ar, $r, or;
    or = {};
    function St(t) {
      if (Me.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function Rt(t) {
      if (Me.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function wt(t, s) {
      if (typeof t.ref == "string" && ge.current && s && ge.current.stateNode !== s) {
        var f = K(ge.current.type);
        or[f] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', K(ge.current.type), t.ref), or[f] = !0);
      }
    }
    function Ct(t, s) {
      {
        var f = function() {
          Ar || (Ar = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function Tt(t, s) {
      {
        var f = function() {
          $r || ($r = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var Ot = function(t, s, f, m, R, I, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: f,
        props: S,
        // Record the component responsible for creating this element.
        _owner: I
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Pt(t, s, f, m, R) {
      {
        var I, S = {}, x = null, U = null;
        f !== void 0 && (Nr(f), x = "" + f), Rt(s) && (Nr(s.key), x = "" + s.key), St(s) && (U = s.ref, wt(s, R));
        for (I in s)
          Me.call(s, I) && !xt.hasOwnProperty(I) && (S[I] = s[I]);
        if (t && t.defaultProps) {
          var F = t.defaultProps;
          for (I in F)
            S[I] === void 0 && (S[I] = F[I]);
        }
        if (x || U) {
          var j = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && Ct(S, j), U && Tt(S, j);
        }
        return Ot(t, x, U, R, m, ge.current, S);
      }
    }
    var ir = _.ReactCurrentOwner, kr = _.ReactDebugCurrentFrame;
    function ce(t) {
      if (t) {
        var s = t._owner, f = ae(t.type, t._source, s ? s.type : null);
        kr.setExtraStackFrame(f);
      } else
        kr.setExtraStackFrame(null);
    }
    var sr;
    sr = !1;
    function cr(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Ir() {
      {
        if (ir.current) {
          var t = K(ir.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Nt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), f = t.lineNumber;
          return `

Check your code at ` + s + ":" + f + ".";
        }
        return "";
      }
    }
    var Dr = {};
    function At(t) {
      {
        var s = Ir();
        if (!s) {
          var f = typeof t == "string" ? t : t.displayName || t.name;
          f && (s = `

Check the top-level render call using <` + f + ">.");
        }
        return s;
      }
    }
    function Mr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var f = At(s);
        if (Dr[f])
          return;
        Dr[f] = !0;
        var m = "";
        t && t._owner && t._owner !== ir.current && (m = " It was passed a child from " + K(t._owner.type) + "."), ce(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, m), ce(null);
      }
    }
    function Fr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (ar(t))
          for (var f = 0; f < t.length; f++) {
            var m = t[f];
            cr(m) && Mr(m, s);
          }
        else if (cr(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = D(t);
          if (typeof R == "function" && R !== t.entries)
            for (var I = R.call(t), S; !(S = I.next()).done; )
              cr(S.value) && Mr(S.value, s);
        }
      }
    }
    function $t(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var f;
        if (typeof s == "function")
          f = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === E))
          f = s.propTypes;
        else
          return;
        if (f) {
          var m = K(s);
          Et(f, t.props, "prop", m, t);
        } else if (s.PropTypes !== void 0 && !sr) {
          sr = !0;
          var R = K(s);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function kt(t) {
      {
        for (var s = Object.keys(t.props), f = 0; f < s.length; f++) {
          var m = s[f];
          if (m !== "children" && m !== "key") {
            ce(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), ce(null);
            break;
          }
        }
        t.ref !== null && (ce(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), ce(null));
      }
    }
    function Lr(t, s, f, m, R, I) {
      {
        var S = Qe(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var U = Nt(R);
          U ? x += U : x += Ir();
          var F;
          t === null ? F = "null" : ar(t) ? F = "array" : t !== void 0 && t.$$typeof === r ? (F = "<" + (K(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : F = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", F, x);
        }
        var j = Pt(t, s, f, R, I);
        if (j == null)
          return j;
        if (S) {
          var G = s.children;
          if (G !== void 0)
            if (m)
              if (ar(G)) {
                for (var fe = 0; fe < G.length; fe++)
                  Fr(G[fe], t);
                Object.freeze && Object.freeze(G);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Fr(G, t);
        }
        return t === a ? kt(j) : $t(j), j;
      }
    }
    function It(t, s, f) {
      return Lr(t, s, f, !0);
    }
    function Dt(t, s, f) {
      return Lr(t, s, f, !1);
    }
    var Mt = Dt, Ft = It;
    _e.Fragment = a, _e.jsx = Mt, _e.jsxs = Ft;
  }()), _e;
}
process.env.NODE_ENV === "production" ? pr.exports = Wt() : pr.exports = zt();
var Se = pr.exports;
function Ut(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Bt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var qt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Bt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var l = Ut(o);
      try {
        l.insertRule(a, l.cssRules.length);
      } catch (u) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', u);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), z = "-ms-", qe = "-moz-", w = "-webkit-", _r = "comm", xr = "rule", Sr = "decl", Gt = "@import", rt = "@keyframes", Kt = "@layer", Ht = Math.abs, He = String.fromCharCode, Jt = Object.assign;
function Zt(e, r) {
  return W(e, 0) ^ 45 ? (((r << 2 ^ W(e, 0)) << 2 ^ W(e, 1)) << 2 ^ W(e, 2)) << 2 ^ W(e, 3) : 0;
}
function tt(e) {
  return e.trim();
}
function Xt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function C(e, r, n) {
  return e.replace(r, n);
}
function vr(e, r) {
  return e.indexOf(r);
}
function W(e, r) {
  return e.charCodeAt(r) | 0;
}
function Re(e, r, n) {
  return e.slice(r, n);
}
function J(e) {
  return e.length;
}
function Rr(e) {
  return e.length;
}
function Le(e, r) {
  return r.push(e), e;
}
function Qt(e, r) {
  return e.map(r).join("");
}
var Je = 1, le = 1, nt = 0, B = 0, Y = 0, de = "";
function Ze(e, r, n, a, o, i, l) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: Je, column: le, length: l, return: "" };
}
function xe(e, r) {
  return Jt(Ze("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function en() {
  return Y;
}
function rn() {
  return Y = B > 0 ? W(de, --B) : 0, le--, Y === 10 && (le = 1, Je--), Y;
}
function q() {
  return Y = B < nt ? W(de, B++) : 0, le++, Y === 10 && (le = 1, Je++), Y;
}
function Z() {
  return W(de, B);
}
function Ye() {
  return B;
}
function Te(e, r) {
  return Re(de, e, r);
}
function we(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function at(e) {
  return Je = le = 1, nt = J(de = e), B = 0, [];
}
function ot(e) {
  return de = "", e;
}
function We(e) {
  return tt(Te(B - 1, hr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function tn(e) {
  for (; (Y = Z()) && Y < 33; )
    q();
  return we(e) > 2 || we(Y) > 3 ? "" : " ";
}
function nn(e, r) {
  for (; --r && q() && !(Y < 48 || Y > 102 || Y > 57 && Y < 65 || Y > 70 && Y < 97); )
    ;
  return Te(e, Ye() + (r < 6 && Z() == 32 && q() == 32));
}
function hr(e) {
  for (; q(); )
    switch (Y) {
      case e:
        return B;
      case 34:
      case 39:
        e !== 34 && e !== 39 && hr(Y);
        break;
      case 40:
        e === 41 && hr(e);
        break;
      case 92:
        q();
        break;
    }
  return B;
}
function an(e, r) {
  for (; q() && e + Y !== 47 + 10; )
    if (e + Y === 42 + 42 && Z() === 47)
      break;
  return "/*" + Te(r, B - 1) + "*" + He(e === 47 ? e : q());
}
function on(e) {
  for (; !we(Z()); )
    q();
  return Te(e, B);
}
function sn(e) {
  return ot(ze("", null, null, null, [""], e = at(e), 0, [0], e));
}
function ze(e, r, n, a, o, i, l, u, p) {
  for (var h = 0, d = 0, E = l, N = 0, $ = 0, A = 0, b = 1, D = 1, _ = 1, g = 0, T = "", k = o, c = i, L = a, y = T; D; )
    switch (A = g, g = q()) {
      case 40:
        if (A != 108 && W(y, E - 1) == 58) {
          vr(y += C(We(g), "&", "&\f"), "&\f") != -1 && (_ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        y += We(g);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        y += tn(A);
        break;
      case 92:
        y += nn(Ye() - 1, 7);
        continue;
      case 47:
        switch (Z()) {
          case 42:
          case 47:
            Le(cn(an(q(), Ye()), r, n), p);
            break;
          default:
            y += "/";
        }
        break;
      case 123 * b:
        u[h++] = J(y) * _;
      case 125 * b:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            D = 0;
          case 59 + d:
            _ == -1 && (y = C(y, /\f/g, "")), $ > 0 && J(y) - E && Le($ > 32 ? zr(y + ";", a, n, E - 1) : zr(C(y, " ", "") + ";", a, n, E - 2), p);
            break;
          case 59:
            y += ";";
          default:
            if (Le(L = Wr(y, r, n, h, d, o, u, T, k = [], c = [], E), i), g === 123)
              if (d === 0)
                ze(y, r, L, L, k, i, E, u, c);
              else
                switch (N === 99 && W(y, 3) === 110 ? 100 : N) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    ze(e, L, L, a && Le(Wr(e, L, L, 0, 0, o, u, T, o, k = [], E), c), o, c, E, u, a ? k : c);
                    break;
                  default:
                    ze(y, L, L, L, [""], c, 0, u, c);
                }
        }
        h = d = $ = 0, b = _ = 1, T = y = "", E = l;
        break;
      case 58:
        E = 1 + J(y), $ = A;
      default:
        if (b < 1) {
          if (g == 123)
            --b;
          else if (g == 125 && b++ == 0 && rn() == 125)
            continue;
        }
        switch (y += He(g), g * b) {
          case 38:
            _ = d > 0 ? 1 : (y += "\f", -1);
            break;
          case 44:
            u[h++] = (J(y) - 1) * _, _ = 1;
            break;
          case 64:
            Z() === 45 && (y += We(q())), N = Z(), d = E = J(T = y += on(Ye())), g++;
            break;
          case 45:
            A === 45 && J(y) == 2 && (b = 0);
        }
    }
  return i;
}
function Wr(e, r, n, a, o, i, l, u, p, h, d) {
  for (var E = o - 1, N = o === 0 ? i : [""], $ = Rr(N), A = 0, b = 0, D = 0; A < a; ++A)
    for (var _ = 0, g = Re(e, E + 1, E = Ht(b = l[A])), T = e; _ < $; ++_)
      (T = tt(b > 0 ? N[_] + " " + g : C(g, /&\f/g, N[_]))) && (p[D++] = T);
  return Ze(e, r, n, o === 0 ? xr : u, p, h, d);
}
function cn(e, r, n) {
  return Ze(e, r, n, _r, He(en()), Re(e, 2, -2), 0);
}
function zr(e, r, n, a) {
  return Ze(e, r, n, Sr, Re(e, 0, a), Re(e, a + 1, -1), a);
}
function ue(e, r) {
  for (var n = "", a = Rr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function fn(e, r, n, a) {
  switch (e.type) {
    case Kt:
      if (e.children.length)
        break;
    case Gt:
    case Sr:
      return e.return = e.return || e.value;
    case _r:
      return "";
    case rt:
      return e.return = e.value + "{" + ue(e.children, a) + "}";
    case xr:
      e.value = e.props.join(",");
  }
  return J(n = ue(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function un(e) {
  var r = Rr(e);
  return function(n, a, o, i) {
    for (var l = "", u = 0; u < r; u++)
      l += e[u](n, a, o, i) || "";
    return l;
  };
}
function ln(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function dn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var pn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = Z(), o === 38 && i === 12 && (n[a] = 1), !we(i); )
    q();
  return Te(r, B);
}, vn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (we(o)) {
      case 0:
        o === 38 && Z() === 12 && (n[a] = 1), r[a] += pn(B - 1, n, a);
        break;
      case 2:
        r[a] += We(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = Z() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += He(o);
    }
  while (o = q());
  return r;
}, hn = function(r, n) {
  return ot(vn(at(r), n));
}, Ur = /* @__PURE__ */ new WeakMap(), mn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Ur.get(a)) && !o) {
      Ur.set(r, !0);
      for (var i = [], l = hn(n, i), u = a.props, p = 0, h = 0; p < l.length; p++)
        for (var d = 0; d < u.length; d++, h++)
          r.props[h] = i[p] ? l[p].replace(/&\f/g, u[d]) : u[d] + " " + l[p];
    }
  }
}, yn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, En = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", gn = function(r) {
  return r.type === "comm" && r.children.indexOf(En) > -1;
}, bn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var l = !!n.parent, u = l ? n.parent.children : (
          // global rule at the root level
          o
        ), p = u.length - 1; p >= 0; p--) {
          var h = u[p];
          if (h.line < n.line)
            break;
          if (h.column < n.column) {
            if (gn(h))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, it = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, _n = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!it(n[a]))
      return !0;
  return !1;
}, Br = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, xn = function(r, n, a) {
  it(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Br(r)) : _n(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Br(r)));
};
function st(e, r) {
  switch (Zt(e, r)) {
    case 5103:
      return w + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return w + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return w + e + qe + e + z + e + e;
    case 6828:
    case 4268:
      return w + e + z + e + e;
    case 6165:
      return w + e + z + "flex-" + e + e;
    case 5187:
      return w + e + C(e, /(\w+).+(:[^]+)/, w + "box-$1$2" + z + "flex-$1$2") + e;
    case 5443:
      return w + e + z + "flex-item-" + C(e, /flex-|-self/, "") + e;
    case 4675:
      return w + e + z + "flex-line-pack" + C(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return w + e + z + C(e, "shrink", "negative") + e;
    case 5292:
      return w + e + z + C(e, "basis", "preferred-size") + e;
    case 6060:
      return w + "box-" + C(e, "-grow", "") + w + e + z + C(e, "grow", "positive") + e;
    case 4554:
      return w + C(e, /([^-])(transform)/g, "$1" + w + "$2") + e;
    case 6187:
      return C(C(C(e, /(zoom-|grab)/, w + "$1"), /(image-set)/, w + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return C(e, /(image-set\([^]*)/, w + "$1$`$1");
    case 4968:
      return C(C(e, /(.+:)(flex-)?(.*)/, w + "box-pack:$3" + z + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + w + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return C(e, /(.+)-inline(.+)/, w + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (J(e) - 1 - r > 6)
        switch (W(e, r + 1)) {
          case 109:
            if (W(e, r + 4) !== 45)
              break;
          case 102:
            return C(e, /(.+:)(.+)-([^]+)/, "$1" + w + "$2-$3$1" + qe + (W(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~vr(e, "stretch") ? st(C(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (W(e, r + 1) !== 115)
        break;
    case 6444:
      switch (W(e, J(e) - 3 - (~vr(e, "!important") && 10))) {
        case 107:
          return C(e, ":", ":" + w) + e;
        case 101:
          return C(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + w + (W(e, 14) === 45 ? "inline-" : "") + "box$3$1" + w + "$2$3$1" + z + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (W(e, r + 11)) {
        case 114:
          return w + e + z + C(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return w + e + z + C(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return w + e + z + C(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return w + e + z + e + e;
  }
  return e;
}
var Sn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case Sr:
        r.return = st(r.value, r.length);
        break;
      case rt:
        return ue([xe(r, {
          value: C(r.value, "@", "@" + w)
        })], o);
      case xr:
        if (r.length)
          return Qt(r.props, function(i) {
            switch (Xt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ue([xe(r, {
                  props: [C(i, /:(read-\w+)/, ":" + qe + "$1")]
                })], o);
              case "::placeholder":
                return ue([xe(r, {
                  props: [C(i, /:(plac\w+)/, ":" + w + "input-$1")]
                }), xe(r, {
                  props: [C(i, /:(plac\w+)/, ":" + qe + "$1")]
                }), xe(r, {
                  props: [C(i, /:(plac\w+)/, z + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, Rn = [Sn], wn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(b) {
      var D = b.getAttribute("data-emotion");
      D.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || Rn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, l, u = [];
  l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(b) {
      for (var D = b.getAttribute("data-emotion").split(" "), _ = 1; _ < D.length; _++)
        i[D[_]] = !0;
      u.push(b);
    }
  );
  var p, h = [mn, yn];
  process.env.NODE_ENV !== "production" && h.push(bn({
    get compat() {
      return A.compat;
    }
  }), xn);
  {
    var d, E = [fn, process.env.NODE_ENV !== "production" ? function(b) {
      b.root || (b.return ? d.insert(b.return) : b.value && b.type !== _r && d.insert(b.value + "{}"));
    } : ln(function(b) {
      d.insert(b);
    })], N = un(h.concat(o, E)), $ = function(D) {
      return ue(sn(D), N);
    };
    p = function(D, _, g, T) {
      d = g, process.env.NODE_ENV !== "production" && _.map !== void 0 && (d = {
        insert: function(c) {
          g.insert(c + _.map);
        }
      }), $(D ? D + "{" + _.styles + "}" : _.styles), T && (A.inserted[_.name] = !0);
    };
  }
  var A = {
    key: n,
    sheet: new qt({
      key: n,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return A.sheet.hydrate(u), A;
}, mr = { exports: {} }, O = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qr;
function Cn() {
  if (qr)
    return O;
  qr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, E = e ? Symbol.for("react.suspense") : 60113, N = e ? Symbol.for("react.suspense_list") : 60120, $ = e ? Symbol.for("react.memo") : 60115, A = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function T(c) {
    if (typeof c == "object" && c !== null) {
      var L = c.$$typeof;
      switch (L) {
        case r:
          switch (c = c.type, c) {
            case p:
            case h:
            case a:
            case i:
            case o:
            case E:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case u:
                case d:
                case A:
                case $:
                case l:
                  return c;
                default:
                  return L;
              }
          }
        case n:
          return L;
      }
    }
  }
  function k(c) {
    return T(c) === h;
  }
  return O.AsyncMode = p, O.ConcurrentMode = h, O.ContextConsumer = u, O.ContextProvider = l, O.Element = r, O.ForwardRef = d, O.Fragment = a, O.Lazy = A, O.Memo = $, O.Portal = n, O.Profiler = i, O.StrictMode = o, O.Suspense = E, O.isAsyncMode = function(c) {
    return k(c) || T(c) === p;
  }, O.isConcurrentMode = k, O.isContextConsumer = function(c) {
    return T(c) === u;
  }, O.isContextProvider = function(c) {
    return T(c) === l;
  }, O.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, O.isForwardRef = function(c) {
    return T(c) === d;
  }, O.isFragment = function(c) {
    return T(c) === a;
  }, O.isLazy = function(c) {
    return T(c) === A;
  }, O.isMemo = function(c) {
    return T(c) === $;
  }, O.isPortal = function(c) {
    return T(c) === n;
  }, O.isProfiler = function(c) {
    return T(c) === i;
  }, O.isStrictMode = function(c) {
    return T(c) === o;
  }, O.isSuspense = function(c) {
    return T(c) === E;
  }, O.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === h || c === i || c === o || c === E || c === N || typeof c == "object" && c !== null && (c.$$typeof === A || c.$$typeof === $ || c.$$typeof === l || c.$$typeof === u || c.$$typeof === d || c.$$typeof === D || c.$$typeof === _ || c.$$typeof === g || c.$$typeof === b);
  }, O.typeOf = T, O;
}
var P = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gr;
function Tn() {
  return Gr || (Gr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, E = e ? Symbol.for("react.suspense") : 60113, N = e ? Symbol.for("react.suspense_list") : 60120, $ = e ? Symbol.for("react.memo") : 60115, A = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function T(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === h || v === i || v === o || v === E || v === N || typeof v == "object" && v !== null && (v.$$typeof === A || v.$$typeof === $ || v.$$typeof === l || v.$$typeof === u || v.$$typeof === d || v.$$typeof === D || v.$$typeof === _ || v.$$typeof === g || v.$$typeof === b);
    }
    function k(v) {
      if (typeof v == "object" && v !== null) {
        var Ee = v.$$typeof;
        switch (Ee) {
          case r:
            var se = v.type;
            switch (se) {
              case p:
              case h:
              case a:
              case i:
              case o:
              case E:
                return se;
              default:
                var ae = se && se.$$typeof;
                switch (ae) {
                  case u:
                  case d:
                  case A:
                  case $:
                  case l:
                    return ae;
                  default:
                    return Ee;
                }
            }
          case n:
            return Ee;
        }
      }
    }
    var c = p, L = h, y = u, X = l, Oe = r, Qe = d, er = a, Pe = A, K = $, Q = n, ne = i, Ne = o, Ae = E, pe = !1;
    function $e(v) {
      return pe || (pe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ve(v) || k(v) === p;
    }
    function ve(v) {
      return k(v) === h;
    }
    function ke(v) {
      return k(v) === u;
    }
    function Ie(v) {
      return k(v) === l;
    }
    function De(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function rr(v) {
      return k(v) === d;
    }
    function tr(v) {
      return k(v) === a;
    }
    function he(v) {
      return k(v) === A;
    }
    function me(v) {
      return k(v) === $;
    }
    function oe(v) {
      return k(v) === n;
    }
    function ye(v) {
      return k(v) === i;
    }
    function ie(v) {
      return k(v) === o;
    }
    function nr(v) {
      return k(v) === E;
    }
    P.AsyncMode = c, P.ConcurrentMode = L, P.ContextConsumer = y, P.ContextProvider = X, P.Element = Oe, P.ForwardRef = Qe, P.Fragment = er, P.Lazy = Pe, P.Memo = K, P.Portal = Q, P.Profiler = ne, P.StrictMode = Ne, P.Suspense = Ae, P.isAsyncMode = $e, P.isConcurrentMode = ve, P.isContextConsumer = ke, P.isContextProvider = Ie, P.isElement = De, P.isForwardRef = rr, P.isFragment = tr, P.isLazy = he, P.isMemo = me, P.isPortal = oe, P.isProfiler = ye, P.isStrictMode = ie, P.isSuspense = nr, P.isValidElementType = T, P.typeOf = k;
  }()), P;
}
process.env.NODE_ENV === "production" ? mr.exports = Cn() : mr.exports = Tn();
var On = mr.exports, ct = On, Pn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Nn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, ft = {};
ft[ct.ForwardRef] = Pn;
ft[ct.Memo] = Nn;
var An = !0;
function $n(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var ut = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  An === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, kn = function(r, n, a) {
  ut(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function In(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Dn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Kr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Mn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Fn = /[A-Z]|^ms/g, lt = /_EMO_([^_]+?)_([^]*?)_EMO_/g, wr = function(r) {
  return r.charCodeAt(1) === 45;
}, Hr = function(r) {
  return r != null && typeof r != "boolean";
}, ur = /* @__PURE__ */ dn(function(e) {
  return wr(e) ? e : e.replace(Fn, "-$&").toLowerCase();
}), Ge = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(lt, function(a, o, i) {
          return H = {
            name: o,
            styles: i,
            next: H
          }, o;
        });
  }
  return Dn[r] !== 1 && !wr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Ln = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, jn = ["normal", "none", "initial", "inherit", "unset"], Vn = Ge, Yn = /^-ms-/, Wn = /-(.)/g, Jr = {};
  Ge = function(r, n) {
    if (r === "content" && (typeof n != "string" || jn.indexOf(n) === -1 && !Ln.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = Vn(r, n);
    return a !== "" && !wr(r) && r.indexOf("-") !== -1 && Jr[r] === void 0 && (Jr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Yn, "ms-").replace(Wn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var dt = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Ce(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(dt);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return H = {
          name: n.name,
          styles: n.styles,
          next: H
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            H = {
              name: a.name,
              styles: a.styles,
              next: H
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return zn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = H, l = n(e);
        return H = i, Ce(e, r, l);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var u = [], p = n.replace(lt, function(d, E, N) {
          var $ = "animation" + u.length;
          return u.push("const " + $ + " = keyframes`" + N.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + $ + "}";
        });
        u.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(u, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var h = r[n];
  return h !== void 0 ? h : n;
}
function zn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Ce(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var l = n[i];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? a += i + "{" + r[l] + "}" : Hr(l) && (a += ur(i) + ":" + Ge(i, l) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(dt);
        if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
          for (var u = 0; u < l.length; u++)
            Hr(l[u]) && (a += ur(i) + ":" + Ge(i, l[u]) + ";");
        else {
          var p = Ce(e, r, l);
          switch (i) {
            case "animation":
            case "animationName": {
              a += ur(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Mn), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Zr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, pt;
process.env.NODE_ENV !== "production" && (pt = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var H, Xr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  H = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (o = !1, i += Ce(a, n, l)) : (process.env.NODE_ENV !== "production" && l[0] === void 0 && console.error(Kr), i += l[0]);
  for (var u = 1; u < r.length; u++)
    i += Ce(a, n, r[u]), o && (process.env.NODE_ENV !== "production" && l[u] === void 0 && console.error(Kr), i += l[u]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(pt, function(N) {
    return p = N, "";
  })), Zr.lastIndex = 0;
  for (var h = "", d; (d = Zr.exec(i)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    d[1];
  var E = In(i) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: E,
    styles: i,
    map: p,
    next: H,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: E,
    styles: i,
    next: H
  };
}, Un = function(r) {
  return r();
}, Bn = re["useInsertionEffect"] ? re["useInsertionEffect"] : !1, qn = Bn || Un, Xe = {}.hasOwnProperty, Cr = /* @__PURE__ */ re.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ wn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Cr.displayName = "EmotionCacheContext");
Cr.Provider;
var Gn = function(r) {
  return /* @__PURE__ */ Ke(function(n, a) {
    var o = Lt(Cr);
    return r(n, o, a);
  });
}, vt = /* @__PURE__ */ re.createContext({});
process.env.NODE_ENV !== "production" && (vt.displayName = "EmotionThemeContext");
var Qr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Kn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Qr(n[1]);
}, Hn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Jn = function(r) {
  return r.replace(/\$/g, "-");
}, Zn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Kn(n[a]);
      if (o) {
        if (Hn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Jn(o);
      }
    }
}, yr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Er = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", ht = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Xe.call(n, o) && (a[o] = n[o]);
  if (a[yr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Zn(new Error().stack);
    i && (a[Er] = i);
  }
  return a;
}, Xn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return ut(n, a, o), qn(function() {
    return kn(n, a, o);
  }), null;
}, mt = /* @__PURE__ */ Gn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[yr], i = [a], l = "";
  typeof e.className == "string" ? l = $n(r.registered, i, e.className) : e.className != null && (l = e.className + " ");
  var u = Xr(i, void 0, re.useContext(vt));
  if (process.env.NODE_ENV !== "production" && u.name.indexOf("-") === -1) {
    var p = e[Er];
    p && (u = Xr([u, "label:" + p + ";"]));
  }
  l += r.key + "-" + u.name;
  var h = {};
  for (var d in e)
    Xe.call(e, d) && d !== "css" && d !== yr && (process.env.NODE_ENV === "production" || d !== Er) && (h[d] = e[d]);
  return h.ref = n, h.className = l, /* @__PURE__ */ re.createElement(re.Fragment, null, /* @__PURE__ */ re.createElement(Xn, {
    cache: r,
    serialized: u,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ re.createElement(o, h));
});
process.env.NODE_ENV !== "production" && (mt.displayName = "EmotionCssPropInternal");
var yt = mt, je = Se.Fragment;
function V(e, r, n) {
  return Xe.call(r, "css") ? Se.jsx(yt, ht(e, r), n) : Se.jsx(e, r, n);
}
function te(e, r, n) {
  return Xe.call(r, "css") ? Se.jsxs(yt, ht(e, r), n) : Se.jsxs(e, r, n);
}
function Qn(e) {
  let r = M`
    display: inline-flex;
    flex-direction: column;
  `;
  return e && (r = M`
      ${r};
      border: solid 1px ${Ue(`--${Be}-grayBlue-09`)};
      border-radius: 2px;
    `), r;
}
function ea(e) {
  let r = M``;
  return e && (r = M`
      &:hover {
        background-color: ${Ue(`--${Be}-grayBlue-09`)};
      }
    `), M`
    ${r};
  `;
}
function ra(e) {
  let r;
  switch (e) {
    case "small":
      r = M`
        padding: 8px 16px;
      `;
      break;
    case "medium":
      r = M`
        padding: 12px 16px;
      `;
      break;
    case "large":
      r = M`
        padding: 16px 16px;
      `;
      break;
  }
  return M`
    display: flex;
    flex-direction: row;
    ${r};
  `;
}
const ta = M`
  display: inline-flex;
  flex-direction: column;
  flex-grow: 1;
`;
function na() {
  return M`
    display: inline-flex;
    align-items: start;
    flex-direction: row;
  `;
}
const aa = M`
  margin-right: 8px;
`, oa = M`
  align-self: center;
`, ia = M`
  margin-top: 8px;
`, sa = M`
  display: flex;
  align-items: center;
  margin-left: 32px;
`;
function Ve(e) {
  let r;
  switch (e) {
    case "small":
      r = M`
        padding: 8px 16px;
      `;
      break;
    case "medium":
      r = M`
        padding: 12px 16px;
      `;
      break;
    case "large":
      r = M`
        padding: 16px 16px;
      `;
      break;
  }
  return M`
    ${r};
  `;
}
const ca = M`
  display: inline-flex;
`, fa = Ke((e, r) => {
  const { data: n, size: a = "medium", bordered: o = !0, split: i = !0, hoverable: l, header: u, footer: p, height: h, render: d, renderRaw: E, renderKey: N, bottomOffset: $ = 0, topOffset: A = 0, onReachBottom: b, onReachTop: D, hasMore: _, loader: g, endMessage: T, itemHeight: k, onScroll: c, ...L } = e;
  return te("div", { css: M(Qn(o), gr(e)), ref: r, ...br(L), children: [u && te(je, { children: [typeof u == "string" ? V("div", { css: Ve(a), children: V(lr, { children: V(dr, { bold: !0, colorScheme: "gray", children: u }) }) }) : V("div", { css: Ve(a), children: u }), V(fr, { direction: "horizontal" })] }), n && d && N && V(jt, { height: h, data: n, virtual: h != null && k != null, fullHeight: h === void 0, itemKey: (y) => N(y, n.indexOf(y)), itemHeight: k, onScroll: (y) => {
    c != null && c(y), b != null && y.currentTarget.scrollHeight - (y.currentTarget.scrollTop + y.currentTarget.clientHeight) <= $ && b(), D != null && y.currentTarget.scrollTop <= A && D();
  }, children: (y) => {
    let X;
    return n.indexOf(y) != n.length - 1 ? i && (X = V(fr, { direction: "horizontal" })) : _ != null && (_ ? X = g : X = T), E ? te(je, { children: [d(y, n.indexOf(y)), X] }) : te(je, { children: [V("div", { css: ea(l), children: d(y, n.indexOf(y)) }), X] });
  } }), p && te(je, { children: [V(fr, { direction: "horizontal" }), typeof p == "string" ? V("div", { css: Ve(a), children: V(lr, { children: V(dr, { bold: !0, colorScheme: "gray", children: p }) }) }) : V("div", { css: Ve(a), children: p })] })] });
});
fa.displayName = "List";
const ua = Ke((e, r) => {
  const { actions: n, extra: a, size: o = "medium", ...i } = e;
  return te("div", { css: M(ra(o), gr(e)), ref: r, ...br(i), children: [te("div", { css: ta, children: [e.children, n && V("div", { css: ia, children: n })] }), a && V("div", { css: sa, children: a })] });
});
ua.displayName = "ListItem";
const la = Ke((e, r) => {
  const { title: n, avatar: a, description: o, ...i } = e;
  return te("div", { css: [na(), gr(e)], ref: r, ...br(i), children: [a && V(Yt, { css: aa, size: "medium", shape: "square", src: a }), te(lr, { css: oa, children: [n && typeof n == "string" ? V(dr, { fs: "14px", fw: "500", colorScheme: "gray", children: n }) : V("div", { css: ca, children: n }), n && o && V("div", { style: { height: "4px" } }), o && V(Vt, { fs: "14px", colorScheme: n == null ? Ue(`--${Be}-grayBlue-02`) : Ue(`--${Be}-grayBlue-04`), children: o })] })] });
});
la.displayName = "ListItemMeta";
export {
  fa as List,
  ua as ListItem,
  la as ListItemMeta
};
//# sourceMappingURL=index.js.map
